import { render, staticRenderFns } from "./form-quantity.vue?vue&type=template&id=77b18136&scoped=true"
import script from "./form-quantity.vue?vue&type=script&lang=js"
export * from "./form-quantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b18136",
  null
  
)

export default component.exports